"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User_Update_Column = exports.User_Select_Column = exports.User_Constraint = exports.Report_Update_Column = exports.Report_Select_Column = exports.Report_Constraint = exports.Order_By = exports.Farm_Update_Column = exports.Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = exports.Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = exports.Farm_Select_Column = exports.Farm_Constraint = exports.Enum_User_Role_Update_Column = exports.Enum_User_Role_Select_Column = exports.Enum_User_Role_Enum = exports.Enum_User_Role_Constraint = exports.Enum_Measurement_System_Update_Column = exports.Enum_Measurement_System_Select_Column = exports.Enum_Measurement_System_Enum = exports.Enum_Measurement_System_Constraint = exports.Enum_Calculator_Update_Column = exports.Enum_Calculator_Select_Column = exports.Enum_Calculator_Enum = exports.Enum_Calculator_Constraint = exports.Cursor_Ordering = exports.Calf_Update_Column = exports.Calf_Select_Column = exports.Calf_Constraint = exports.Calculation_Update_Column = exports.Calculation_Select_Column = exports.Calculation_Constraint = exports.ModuleRequestAccessEnum = void 0;
var ModuleRequestAccessEnum;
(function (ModuleRequestAccessEnum) {
    ModuleRequestAccessEnum["CalfMilkRation"] = "calf_milk_ration";
    ModuleRequestAccessEnum["ColostrumReplacer"] = "colostrum_replacer";
})(ModuleRequestAccessEnum || (exports.ModuleRequestAccessEnum = ModuleRequestAccessEnum = {}));
/** unique or primary key constraints on table "calculation" */
var Calculation_Constraint;
(function (Calculation_Constraint) {
    /** unique or primary key constraint on columns "id" */
    Calculation_Constraint["CalculationPkey"] = "calculation_pkey";
})(Calculation_Constraint || (exports.Calculation_Constraint = Calculation_Constraint = {}));
/** select columns of table "calculation" */
var Calculation_Select_Column;
(function (Calculation_Select_Column) {
    /** column name */
    Calculation_Select_Column["Calculator"] = "calculator";
    /** column name */
    Calculation_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Calculation_Select_Column["CreatedById"] = "created_by_id";
    /** column name */
    Calculation_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */
    Calculation_Select_Column["FarmId"] = "farm_id";
    /** column name */
    Calculation_Select_Column["Id"] = "id";
    /** column name */
    Calculation_Select_Column["Inputs"] = "inputs";
    /** column name */
    Calculation_Select_Column["Name"] = "name";
    /** column name */
    Calculation_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */
    Calculation_Select_Column["UpdatedById"] = "updated_by_id";
})(Calculation_Select_Column || (exports.Calculation_Select_Column = Calculation_Select_Column = {}));
/** update columns of table "calculation" */
var Calculation_Update_Column;
(function (Calculation_Update_Column) {
    /** column name */
    Calculation_Update_Column["Calculator"] = "calculator";
    /** column name */
    Calculation_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    Calculation_Update_Column["CreatedById"] = "created_by_id";
    /** column name */
    Calculation_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */
    Calculation_Update_Column["FarmId"] = "farm_id";
    /** column name */
    Calculation_Update_Column["Id"] = "id";
    /** column name */
    Calculation_Update_Column["Inputs"] = "inputs";
    /** column name */
    Calculation_Update_Column["Name"] = "name";
    /** column name */
    Calculation_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */
    Calculation_Update_Column["UpdatedById"] = "updated_by_id";
})(Calculation_Update_Column || (exports.Calculation_Update_Column = Calculation_Update_Column = {}));
/** unique or primary key constraints on table "calf" */
var Calf_Constraint;
(function (Calf_Constraint) {
    /** unique or primary key constraint on columns "id", "farm_id", "deleted_at" */
    Calf_Constraint["CalfIdFarmIdDeletedAtKey"] = "calf_id_farm_id_deleted_at_key";
    /** unique or primary key constraint on columns "system_id" */
    Calf_Constraint["CalfPkey"] = "calf_pkey";
})(Calf_Constraint || (exports.Calf_Constraint = Calf_Constraint = {}));
/** select columns of table "calf" */
var Calf_Select_Column;
(function (Calf_Select_Column) {
    /** column name */
    Calf_Select_Column["BirthBodyWt"] = "birth_body_wt";
    /** column name */
    Calf_Select_Column["ColRepMeasurementSystemId"] = "col_rep_measurement_system_id";
    /** column name */
    Calf_Select_Column["ColostrumFirstFdgBrixReading"] = "colostrum_first_fdg_brix_reading";
    /** column name */
    Calf_Select_Column["ColostrumMaxFirstFdg"] = "colostrum_max_first_fdg";
    /** column name */
    Calf_Select_Column["ColostrumMaxSecondFdg"] = "colostrum_max_second_fdg";
    /** column name */
    Calf_Select_Column["ColostrumSecondFdgBrixReading"] = "colostrum_second_fdg_brix_reading";
    /** column name */
    Calf_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Calf_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */
    Calf_Select_Column["FarmId"] = "farm_id";
    /** column name */
    Calf_Select_Column["Id"] = "id";
    /** column name */
    Calf_Select_Column["SystemId"] = "system_id";
    /** column name */
    Calf_Select_Column["UpdatedAt"] = "updated_at";
})(Calf_Select_Column || (exports.Calf_Select_Column = Calf_Select_Column = {}));
/** update columns of table "calf" */
var Calf_Update_Column;
(function (Calf_Update_Column) {
    /** column name */
    Calf_Update_Column["BirthBodyWt"] = "birth_body_wt";
    /** column name */
    Calf_Update_Column["ColRepMeasurementSystemId"] = "col_rep_measurement_system_id";
    /** column name */
    Calf_Update_Column["ColostrumFirstFdgBrixReading"] = "colostrum_first_fdg_brix_reading";
    /** column name */
    Calf_Update_Column["ColostrumMaxFirstFdg"] = "colostrum_max_first_fdg";
    /** column name */
    Calf_Update_Column["ColostrumMaxSecondFdg"] = "colostrum_max_second_fdg";
    /** column name */
    Calf_Update_Column["ColostrumSecondFdgBrixReading"] = "colostrum_second_fdg_brix_reading";
    /** column name */
    Calf_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    Calf_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */
    Calf_Update_Column["FarmId"] = "farm_id";
    /** column name */
    Calf_Update_Column["Id"] = "id";
    /** column name */
    Calf_Update_Column["SystemId"] = "system_id";
    /** column name */
    Calf_Update_Column["UpdatedAt"] = "updated_at";
})(Calf_Update_Column || (exports.Calf_Update_Column = Calf_Update_Column = {}));
/** ordering argument of a cursor */
var Cursor_Ordering;
(function (Cursor_Ordering) {
    /** ascending ordering of the cursor */
    Cursor_Ordering["Asc"] = "ASC";
    /** descending ordering of the cursor */
    Cursor_Ordering["Desc"] = "DESC";
})(Cursor_Ordering || (exports.Cursor_Ordering = Cursor_Ordering = {}));
/** unique or primary key constraints on table "enum_calculator" */
var Enum_Calculator_Constraint;
(function (Enum_Calculator_Constraint) {
    /** unique or primary key constraint on columns "value" */
    Enum_Calculator_Constraint["EnumCalculatorPkey"] = "enum_calculator_pkey";
})(Enum_Calculator_Constraint || (exports.Enum_Calculator_Constraint = Enum_Calculator_Constraint = {}));
var Enum_Calculator_Enum;
(function (Enum_Calculator_Enum) {
    Enum_Calculator_Enum["CmrSetSolids"] = "cmr_set_solids";
    /** NULL */
    Enum_Calculator_Enum["ColRepPooled"] = "col_rep_pooled";
    Enum_Calculator_Enum["PmWater"] = "pm_water";
    Enum_Calculator_Enum["PmrbNoWater"] = "pmrb_no_water";
})(Enum_Calculator_Enum || (exports.Enum_Calculator_Enum = Enum_Calculator_Enum = {}));
/** select columns of table "enum_calculator" */
var Enum_Calculator_Select_Column;
(function (Enum_Calculator_Select_Column) {
    /** column name */
    Enum_Calculator_Select_Column["DisplayName"] = "display_name";
    /** column name */
    Enum_Calculator_Select_Column["Value"] = "value";
})(Enum_Calculator_Select_Column || (exports.Enum_Calculator_Select_Column = Enum_Calculator_Select_Column = {}));
/** update columns of table "enum_calculator" */
var Enum_Calculator_Update_Column;
(function (Enum_Calculator_Update_Column) {
    /** column name */
    Enum_Calculator_Update_Column["DisplayName"] = "display_name";
    /** column name */
    Enum_Calculator_Update_Column["Value"] = "value";
})(Enum_Calculator_Update_Column || (exports.Enum_Calculator_Update_Column = Enum_Calculator_Update_Column = {}));
/** unique or primary key constraints on table "enum_measurement_system" */
var Enum_Measurement_System_Constraint;
(function (Enum_Measurement_System_Constraint) {
    /** unique or primary key constraint on columns "id" */
    Enum_Measurement_System_Constraint["EnumMeasurementSystemPkey"] = "enum_measurement_system_pkey";
})(Enum_Measurement_System_Constraint || (exports.Enum_Measurement_System_Constraint = Enum_Measurement_System_Constraint = {}));
var Enum_Measurement_System_Enum;
(function (Enum_Measurement_System_Enum) {
    /** Metric */
    Enum_Measurement_System_Enum["Metric"] = "metric";
    /** English */
    Enum_Measurement_System_Enum["UsCustomary"] = "us_customary";
})(Enum_Measurement_System_Enum || (exports.Enum_Measurement_System_Enum = Enum_Measurement_System_Enum = {}));
/** select columns of table "enum_measurement_system" */
var Enum_Measurement_System_Select_Column;
(function (Enum_Measurement_System_Select_Column) {
    /** column name */
    Enum_Measurement_System_Select_Column["DisplayName"] = "display_name";
    /** column name */
    Enum_Measurement_System_Select_Column["Id"] = "id";
})(Enum_Measurement_System_Select_Column || (exports.Enum_Measurement_System_Select_Column = Enum_Measurement_System_Select_Column = {}));
/** update columns of table "enum_measurement_system" */
var Enum_Measurement_System_Update_Column;
(function (Enum_Measurement_System_Update_Column) {
    /** column name */
    Enum_Measurement_System_Update_Column["DisplayName"] = "display_name";
    /** column name */
    Enum_Measurement_System_Update_Column["Id"] = "id";
})(Enum_Measurement_System_Update_Column || (exports.Enum_Measurement_System_Update_Column = Enum_Measurement_System_Update_Column = {}));
/** unique or primary key constraints on table "enum_user_role" */
var Enum_User_Role_Constraint;
(function (Enum_User_Role_Constraint) {
    /** unique or primary key constraint on columns "value" */
    Enum_User_Role_Constraint["EnumUserRolePkey"] = "enum_user_role_pkey";
})(Enum_User_Role_Constraint || (exports.Enum_User_Role_Constraint = Enum_User_Role_Constraint = {}));
var Enum_User_Role_Enum;
(function (Enum_User_Role_Enum) {
    Enum_User_Role_Enum["AppAdmin"] = "app_admin";
    Enum_User_Role_Enum["User"] = "user";
})(Enum_User_Role_Enum || (exports.Enum_User_Role_Enum = Enum_User_Role_Enum = {}));
/** select columns of table "enum_user_role" */
var Enum_User_Role_Select_Column;
(function (Enum_User_Role_Select_Column) {
    /** column name */
    Enum_User_Role_Select_Column["DisplayName"] = "display_name";
    /** column name */
    Enum_User_Role_Select_Column["Value"] = "value";
})(Enum_User_Role_Select_Column || (exports.Enum_User_Role_Select_Column = Enum_User_Role_Select_Column = {}));
/** update columns of table "enum_user_role" */
var Enum_User_Role_Update_Column;
(function (Enum_User_Role_Update_Column) {
    /** column name */
    Enum_User_Role_Update_Column["DisplayName"] = "display_name";
    /** column name */
    Enum_User_Role_Update_Column["Value"] = "value";
})(Enum_User_Role_Update_Column || (exports.Enum_User_Role_Update_Column = Enum_User_Role_Update_Column = {}));
/** unique or primary key constraints on table "farm" */
var Farm_Constraint;
(function (Farm_Constraint) {
    /** unique or primary key constraint on columns "id" */
    Farm_Constraint["FarmPkey"] = "farm_pkey";
})(Farm_Constraint || (exports.Farm_Constraint = Farm_Constraint = {}));
/** select columns of table "farm" */
var Farm_Select_Column;
(function (Farm_Select_Column) {
    /** column name */
    Farm_Select_Column["AddressLine_1"] = "address_line_1";
    /** column name */
    Farm_Select_Column["AddressLine_2"] = "address_line_2";
    /** column name */
    Farm_Select_Column["CalvesCount"] = "calves_count";
    /** column name */
    Farm_Select_Column["City"] = "city";
    /** column name */
    Farm_Select_Column["ColRepIsPooling"] = "col_rep_is_pooling";
    /** column name */
    Farm_Select_Column["ColRepMeasurementSystemId"] = "col_rep_measurement_system_id";
    /** column name */
    Farm_Select_Column["ColostrumMaxFirstFdg"] = "colostrum_max_first_fdg";
    /** column name */
    Farm_Select_Column["ColostrumMaxSecondFdg"] = "colostrum_max_second_fdg";
    /** column name */
    Farm_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Farm_Select_Column["CreatedById"] = "created_by_id";
    /** column name */
    Farm_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */
    Farm_Select_Column["FeedingsPerDay"] = "feedings_per_day";
    /** column name */
    Farm_Select_Column["Id"] = "id";
    /** column name */
    Farm_Select_Column["ManagerEmail"] = "manager_email";
    /** column name */
    Farm_Select_Column["ManagerName"] = "manager_name";
    /** column name */
    Farm_Select_Column["ManagerPhone"] = "manager_phone";
    /** column name */
    Farm_Select_Column["Name"] = "name";
    /** column name */
    Farm_Select_Column["State"] = "state";
    /** column name */
    Farm_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */
    Farm_Select_Column["UpdatedById"] = "updated_by_id";
    /** column name */
    Farm_Select_Column["Zipcode"] = "zipcode";
})(Farm_Select_Column || (exports.Farm_Select_Column = Farm_Select_Column = {}));
/** select "farm_aggregate_bool_exp_bool_and_arguments_columns" columns of table "farm" */
var Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function (Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */
    Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["ColRepIsPooling"] = "col_rep_is_pooling";
})(Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (exports.Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
/** select "farm_aggregate_bool_exp_bool_or_arguments_columns" columns of table "farm" */
var Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function (Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */
    Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["ColRepIsPooling"] = "col_rep_is_pooling";
})(Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (exports.Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
/** update columns of table "farm" */
var Farm_Update_Column;
(function (Farm_Update_Column) {
    /** column name */
    Farm_Update_Column["AddressLine_1"] = "address_line_1";
    /** column name */
    Farm_Update_Column["AddressLine_2"] = "address_line_2";
    /** column name */
    Farm_Update_Column["CalvesCount"] = "calves_count";
    /** column name */
    Farm_Update_Column["City"] = "city";
    /** column name */
    Farm_Update_Column["ColRepIsPooling"] = "col_rep_is_pooling";
    /** column name */
    Farm_Update_Column["ColRepMeasurementSystemId"] = "col_rep_measurement_system_id";
    /** column name */
    Farm_Update_Column["ColostrumMaxFirstFdg"] = "colostrum_max_first_fdg";
    /** column name */
    Farm_Update_Column["ColostrumMaxSecondFdg"] = "colostrum_max_second_fdg";
    /** column name */
    Farm_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    Farm_Update_Column["CreatedById"] = "created_by_id";
    /** column name */
    Farm_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */
    Farm_Update_Column["FeedingsPerDay"] = "feedings_per_day";
    /** column name */
    Farm_Update_Column["Id"] = "id";
    /** column name */
    Farm_Update_Column["ManagerEmail"] = "manager_email";
    /** column name */
    Farm_Update_Column["ManagerName"] = "manager_name";
    /** column name */
    Farm_Update_Column["ManagerPhone"] = "manager_phone";
    /** column name */
    Farm_Update_Column["Name"] = "name";
    /** column name */
    Farm_Update_Column["State"] = "state";
    /** column name */
    Farm_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */
    Farm_Update_Column["UpdatedById"] = "updated_by_id";
    /** column name */
    Farm_Update_Column["Zipcode"] = "zipcode";
})(Farm_Update_Column || (exports.Farm_Update_Column = Farm_Update_Column = {}));
/** column ordering options */
var Order_By;
(function (Order_By) {
    /** in ascending order, nulls last */
    Order_By["Asc"] = "asc";
    /** in ascending order, nulls first */
    Order_By["AscNullsFirst"] = "asc_nulls_first";
    /** in ascending order, nulls last */
    Order_By["AscNullsLast"] = "asc_nulls_last";
    /** in descending order, nulls first */
    Order_By["Desc"] = "desc";
    /** in descending order, nulls first */
    Order_By["DescNullsFirst"] = "desc_nulls_first";
    /** in descending order, nulls last */
    Order_By["DescNullsLast"] = "desc_nulls_last";
})(Order_By || (exports.Order_By = Order_By = {}));
/** unique or primary key constraints on table "report" */
var Report_Constraint;
(function (Report_Constraint) {
    /** unique or primary key constraint on columns "id" */
    Report_Constraint["ReportPkey"] = "report_pkey";
})(Report_Constraint || (exports.Report_Constraint = Report_Constraint = {}));
/** select columns of table "report" */
var Report_Select_Column;
(function (Report_Select_Column) {
    /** column name */
    Report_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Report_Select_Column["CreatedById"] = "created_by_id";
    /** column name */
    Report_Select_Column["Data"] = "data";
    /** column name */
    Report_Select_Column["Id"] = "id";
    /** column name */
    Report_Select_Column["S3Key"] = "s3_key";
})(Report_Select_Column || (exports.Report_Select_Column = Report_Select_Column = {}));
/** update columns of table "report" */
var Report_Update_Column;
(function (Report_Update_Column) {
    /** column name */
    Report_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    Report_Update_Column["CreatedById"] = "created_by_id";
    /** column name */
    Report_Update_Column["Data"] = "data";
    /** column name */
    Report_Update_Column["Id"] = "id";
    /** column name */
    Report_Update_Column["S3Key"] = "s3_key";
})(Report_Update_Column || (exports.Report_Update_Column = Report_Update_Column = {}));
/** unique or primary key constraints on table "user" */
var User_Constraint;
(function (User_Constraint) {
    /** unique or primary key constraint on columns "email" */
    User_Constraint["UserEmailKey"] = "user_email_key";
    /** unique or primary key constraint on columns "pingfederate_uid" */
    User_Constraint["UserPingfederateUidKey"] = "user_pingfederate_uid_key";
    /** unique or primary key constraint on columns "id" */
    User_Constraint["UserPkey"] = "user_pkey";
})(User_Constraint || (exports.User_Constraint = User_Constraint = {}));
/** select columns of table "user" */
var User_Select_Column;
(function (User_Select_Column) {
    /** column name */
    User_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    User_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */
    User_Select_Column["Email"] = "email";
    /** column name */
    User_Select_Column["FirstLoginAt"] = "first_login_at";
    /** column name */
    User_Select_Column["FirstName"] = "first_name";
    /** column name */
    User_Select_Column["Id"] = "id";
    /** column name */
    User_Select_Column["LastName"] = "last_name";
    /** column name */
    User_Select_Column["PingfederateUid"] = "pingfederate_uid";
    /** column name */
    User_Select_Column["Role"] = "role";
    /** column name */
    User_Select_Column["UpdatedAt"] = "updated_at";
})(User_Select_Column || (exports.User_Select_Column = User_Select_Column = {}));
/** update columns of table "user" */
var User_Update_Column;
(function (User_Update_Column) {
    /** column name */
    User_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    User_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */
    User_Update_Column["Email"] = "email";
    /** column name */
    User_Update_Column["FirstLoginAt"] = "first_login_at";
    /** column name */
    User_Update_Column["FirstName"] = "first_name";
    /** column name */
    User_Update_Column["Id"] = "id";
    /** column name */
    User_Update_Column["LastName"] = "last_name";
    /** column name */
    User_Update_Column["PingfederateUid"] = "pingfederate_uid";
    /** column name */
    User_Update_Column["Role"] = "role";
    /** column name */
    User_Update_Column["UpdatedAt"] = "updated_at";
})(User_Update_Column || (exports.User_Update_Column = User_Update_Column = {}));
//# sourceMappingURL=graphql.js.map